const state = {
  params: {
    page: 1,
    per_page: 30,
    q: {
      activity_id: '',
      activity_name: '',
      shop_name: '',
      user_keyword: '',
      sn: '',
      activity_start_time: '',
      activity_end_time: '',
      start_time: '',
      end_time: '',
      pay_start_time: '',
      pay_end_time: '',
      order_status: [],
      pay_status: [],
      refund_status: [],
      payment_type: [],
      status: '',
      referral_code: '',
      tx_sn: '',
      user_id: '',
      order_type: 1,
      rec_status: '' //推荐状态
    }
  },
  downData: [],
  screenItems: []
};

const mutations = {
  changeOrderPage(state, val) {
    state.params = val;
  },
  changeOrderDownList(state, val) {
    state.downData = val;
  },
  changeOrderItems(state, val) {
    console.log(val);
    state.screenItems = val;
  }
};

export default {
  state,
  mutations
};
